module.exports = __webpack_public_path__ + "img/pamphlet_thumb01.bc23cea6.png";